export class PartnersModel {
    public CreateBy: string;
    public CreatedDate: Date;
    public Id: number;
    public IdRequest: number;
    public ModifiedBy: string;
    public ModifiedDate: Date;
    public Name: string;
    public LastName: string;
    public Percentage: number;
    public NameOld : string;
    public DocumentNumberOld : string;
    public DocumentNumber : string;
    public PercentageOld : number;
    public IdNationality : string;
    public NationalityName : string;
    public BirthDate: Date;
}
